import Swiper, { Navigation, EffectFade } from "swiper";
import gsap from "gsap";

export default class FloorplanSlider {
    constructor() {
        this.floorBtn = document.querySelectorAll('.js-floor-btn');
        this.slider = '.js-floorplan-slider';
        
        this.init();
    }

    init() {

        const swiper = new Swiper(this.slider, {
            modules: [Navigation, EffectFade],
            loop:false,
            autoHeight: true,
            spaceBetween: 8,
            slidesPerView: 1,
            allowTouchMove: true,
            threshold: 20,
            navigation: {
                nextEl: ".js-floorplan-slider-next",
                prevEl: ".js-floorplan-slider-prev",
            },
            effect: "fade"
        });


        this.floorBtn.forEach(element => {

            element.addEventListener('click', (e) => {
                this.floorBtn.forEach(el => {el.classList.remove('floorplan-nav__btn--active')});
                e.target.classList.add('floorplan-nav__btn--active');
                this.animateNavLine(e.target);
                this.toggleFloor(e.target.dataset.floor);
            });

        });

    }

    animateNavLine(btn, init) {

        gsap.to('.floorplan-nav__slider', 0.3, {
            css:{
                width: btn.offsetWidth+'px',
                left: init ? "auto" : (btn.offsetLeft)+'px'
            },
            overwrite:"all",
        });
        
    }

    toggleFloor(id) {
        document.querySelectorAll("[data-floor-content]").forEach(element => {
            element.classList.add("hidden");
            element.classList.remove("block");
        });
        document.querySelector(`[data-floor-content="${id}"]`).classList.remove("hidden");
        document.querySelector(`[data-floor-content="${id}"]`).classList.add("block");
    }
}

new FloorplanSlider;